import axios from 'axios';
import { amplifyFetchAuthSession, amplifySignOut, isLocalStack } from './amplifyConfig';

const baseURL = `${isLocalStack 
  ? process.env.REACT_APP_API_URL
  : (window.REACT_APP_CONFIG?.API_URL || process.env.REACT_APP_API_URL || '')}`;

// Add /api prefix for local development
const finalBaseURL = process.env.NODE_ENV === 'development' && !baseURL.includes('/api') 
  ? `${baseURL}/api` 
  : baseURL;

const apiClient = axios.create({
  baseURL: finalBaseURL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: false
});

// Add request interceptor to include the access token
// amazonq-ignore-next-line
apiClient.interceptors.request.use(async (config) => {
  if (isLocalStack) {
    // Add mock auth header for LocalStack
    config.headers.Authorization = 'Bearer mock-token-localstack';
    return config;
  }
  
  try {
    const session = await amplifyFetchAuthSession();
    const token = session.tokens?.accessToken?.toString();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (error) {
    throw new Error('Authentication required');
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Check if we got a 401 with JSON error for disabled account
    if (error.response?.status === 401 && error.response?.data?.error === 'Account Disabled') {
      try {
        if (!isLocalStack) {
          await amplifySignOut();
        }
      } catch (signOutError) {
        console.error('Error signing out:', signOutError);
      } finally {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/';
      }
      return Promise.reject(error);
    }
    
    if (error.response?.status === 401 && !isLocalStack) {
      const tokenExpired = error.response.headers['token-expired'] === 'true';
      
      if (tokenExpired || error.response.data?.includes?.('token') || 
          error.response.data?.includes?.('expired')) {
        try {
          await amplifySignOut();
        } catch (signOutError) {
          console.error('Error signing out:', signOutError);
          localStorage.clear();
          sessionStorage.clear();
        } finally {
          window.location.href = '/';
        }
      }
    }
    return Promise.reject(error);
  }
);



export default apiClient;
